window.__sweet = typeof window.__sweet !== 'undefined' ? window.__sweet : {};
window.__sweet.sweet_global_event_list =
    typeof window.__sweet.sweet_global_event_list !== 'undefined'
        ? window.__sweet.sweet_global_event_list
        : {};

const eventBus = {
    // 单次监听，注册
    $onceOn: (evt, fn) => {
        // 覆盖之前绑定的
        window.__sweet.sweet_global_event_list[evt] = [fn];
    },

    // 监听，或者说是发布
    $on: (evt, fn) => {
        const eventList = window.__sweet.sweet_global_event_list[evt];
        if (eventList) {
            eventList.push(fn);
        } else {
            window.__sweet.sweet_global_event_list[evt] = [fn];
        }
    },
    // 触发，订阅
    $emit: (evt, ...args) => {
        window.__sweet.sweet_global_event_list[evt] &&
            window.__sweet.sweet_global_event_list[evt].forEach((fn) => {
                fn(...args);
            });
    },
    // 删除单个事件
    clearEvent: (evt) => {
        const eventList = window.__sweet.sweet_global_event_list[evt];
        if (eventList) {
            window.__sweet.sweet_global_event_list[evt] = [];
        }
    },
    // 删除所有事件
    clearAllEvent: () => {
        Object.keys(window.__sweet.sweet_global_event_list).forEach((evt) => {
            const eventList = window.__sweet.sweet_global_event_list[evt];
            if (eventList) {
                window.__sweet.sweet_global_event_list[evt] = [];
            }
        });
    },
};

export default eventBus;
